import { API_KEYS, CONTACT } from '../../__constants__';

const NoSearchResults = ({ searchType, showMe }) => {
    const noResultsHeading = searchType => {
        if (searchType === 'name') {
            return `We couldn’t find an adviser matching that name`;
        }

        if (searchType === 'location' && showMe && showMe === 'firms') {
            return `We're sorry we haven't found any firms in this location`;
        }

        if (searchType === 'location') {
            return `We're sorry we haven't found any advisers in this location matching these filters`;
        }

        if (searchType === 'location-advice-areas') {
            return `Please complete the highlighted field to see results`;
        }
    }

    const noResultsText = searchType => {
        if (searchType === 'name') {
            return (
                <span>
                    If you are professionally qualified you can
                    <a href={`${API_KEYS.ACCOUNTS_URL}/register`} className='text-primary-blue no-underline'> sign up </a>
                    now as a solicitor, accountant, independent financial adviser or mortgage adviser.
                </span>
            );
        }

        if (searchType === 'location' && showMe && showMe === 'firms') {
            return `Please check your spelling or try entering your postcode or a nearby town`;
        }

        if (searchType === 'location') {
            return `Please check your spelling, try entering your postcode or a nearby town, or try adjusting the filters`;
        }
    }

    return (
        <div className='max-sm:py-6 flex text-center items-center flex-col'>
            <p className='text-primary-blue mb-2 text-[1.1rem] font-normal leading-[1.5] m-0'>
                <strong>
                    { noResultsHeading(searchType) }
                </strong>
            </p>

            <p className='text-primary-blue mb-2 text-[1.1rem] font-normal leading-[1.5] m-0'>
                { noResultsText(searchType) }
            </p>

            <p className='text-primary-blue mb-2 text-[1.1rem] font-normal leading-[1.5] m-0'>
                <strong>
                    If you need help finding the right adviser, call our expert team on <span>{ CONTACT.ACCOUNTS_TEAM_NUMBER }</span>
                </strong>
            </p>
        </div>
    );
};

export default NoSearchResults;
